import { mapGetters } from "vuex";
import { scrollPropertyIntoView } from "@/modules/property/helpers/";

export default {
  name: "layout-controller",
  inject: ["EventBus"],
  mounted() {
    document.body.classList.remove("layout-base");
    this.addBodyClass("layout-page-with-map");
  },
  computed: {
    ...mapGetters({
      resultType: "property/resultType",
      selectedPropertyId: "household/selectedPropertyId",
    }),
  },
  watch: {
    resultType: function (val) {
      document.body.classList.remove([
        "with-results",
        "no-accessible-results",
        "no-results",
      ]);

      this.addBodyClass(val);
    },
    selectedPropertyId: function (id) {
      if (id) {
        window.setTimeout(() => {
          scrollPropertyIntoView(this.selectedPropertyId);
        }, 200);
      }
    },
  },
  methods: {
    addBodyClass(klass) {
      document.body.classList.add(klass);
    },
  },
};
